module.exports = __webpack_public_path__ + "static/media/loading-bars.91ce9af6.svg";